class PasswordMatch {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$form = this.$el.closest('form')
    this.$confirm = this.$form.find('[data-password-match="confirm"]');
    
    this.pwValue = '';
    this.confirmValue = '';

    this.onChangePasswordInput = this.onChangePasswordInput.bind(this);
    this.onChangeConfirmInput = this.onChangeConfirmInput.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    this.$el.on('change', this.onChangePasswordInput);
    this.$confirm.on('change', this.onChangeConfirmInput);
    this.$form.on('submit', this.onFormSubmit);
  }

  onChangePasswordInput(e) {
    this.pwValue = $(e.currentTarget).val();
  }

  onChangeConfirmInput(e) {
    this.confirmValue = $(e.currentTarget).val();
  }

  onFormSubmit(e) {
    if (this.pwValue && this.confirmValue && this.pwValue !== this.confirmValue) {
      e.preventDefault();
      window.scrollTo({ top: 300, behavior: 'smooth' });
      return false;
    }
  }

  static init() {
    $('[data-password-match="password"]').each((i, el) => new PasswordMatch(el));
  }
}

PasswordMatch.init();
